import * as ng from 'angular';

ng.module('e360').directive('onHeightChange', function() {
   return {
      restrict: 'A',
      scope: {
         onHeightChange: '&'
      },
      link: onHeightChangeLink
   }
});

interface Scope extends ng.IScope {
   onHeightChange({$height:number});
}

export function onHeightChangeLink(scope:Scope, element:ng.IAugmentedJQuery, attr) {
   scope.$watch(() => element.height(), onHeightChange);

   function onHeightChange(newHeight:number, oldHeight:number) {
      scope.onHeightChange({$height: newHeight});
   }
}
